import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SigninComponent } from './components/signin/signin.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SigninSignupService } from './signin-signup.service';
import { SignupComponent } from './components/signup/signup.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PerfectScrollbarModule],
  declarations: [
  	SigninComponent,
  	SignupComponent
  ],
  providers: [
  	SigninSignupService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
  ],
  exports: [
  	SigninComponent,
  	SignupComponent
  ]
})
export class SigninSignupModule {}



// WEBPACK FOOTER //
// ./src/app/modules/signin-signup/signin-signup.module.ts